export default __webpack_public_path__ + "static/media/icone-facebook-redondo-branco.700ed187.svg";